// Central place to manage SEO keywords per brand.
// Keying by brand name keeps it consistent across environments/domains.
//
// How it works:
// - `App` (src/app.jsx) reads `brandName` from `/Account/GetSetting`
// - We normalize it (trim/lowercase) and look up here
//
// Add your brands below:
//   "riocity": "rio city, casino, slots, sports betting",
//   "el77": "el77, casino, slots, sportsbook",
export const BRAND_SEO_KEYWORDS = {
  // Example:
  // "riocity": "rio city, casino, slots, sportsbook, live casino"
};


